import { render, staticRenderFns } from "./DashboardLabelNew.vue?vue&type=template&id=31c73e63"
import script from "./DashboardLabelNew.vue?vue&type=script&lang=js"
export * from "./DashboardLabelNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports